(function () {
  var nav = document.querySelector('[data-cdi-dv-nav]');
  if (!nav || nav.dataset.cdiInit) return;
  nav.dataset.cdiInit = '1';

  var list = nav.querySelector('[data-cdi-dv-nav-list]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var items = [];
  Array.prototype.forEach.call(nav.querySelectorAll('a[href^="#"]'), function (a) {
    var el = document.getElementById(decodeURIComponent(a.hash.slice(1)));
    if (el) items.push({ a: a, el: el });
  });
  if (!items.length) return;
  var gaps = Array.prototype.slice.call(document.querySelectorAll('[data-cdi-dv-nav-gap]'));

  var current = null;
  var lockUntil = 0;

  function setActive(item) {
    if (item === current) return;
    current = item;
    items.forEach(function (it) {
      if (it === item) it.a.setAttribute('aria-current', 'true');
      else it.a.removeAttribute('aria-current');
    });
    if (item && list.scrollWidth > list.clientWidth) {
      list.scrollTo({ left: Math.max(0, item.a.offsetLeft - 20), behavior: reduce.matches ? 'auto' : 'smooth' });
    }
  }

  function update() {
    if (Date.now() < lockUntil) return;
    var line = nav.offsetHeight + 24;
    var found = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].el.getBoundingClientRect().top <= line) found = items[i];
    }
    var last = items[items.length - 1].el.getBoundingClientRect();
    if (found === items[items.length - 1] && last.bottom < line) found = null;
    for (var g = 0; g < gaps.length; g++) {
      var r = gaps[g].getBoundingClientRect();
      if (r.top <= line && r.bottom > line) found = null;
    }
    setActive(found);
  }

  var observer = new IntersectionObserver(update, { rootMargin: '-60px 0px -55% 0px', threshold: [0, 1] });
  items.forEach(function (it) { observer.observe(it.el); });
  gaps.forEach(function (el) { observer.observe(el); });
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; update(); });
  }, { passive: true });

  nav.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var item = items.filter(function (it) { return it.a === a; })[0];
    if (!item) return;
    e.preventDefault();
    lockUntil = Date.now() + 900;
    setActive(item);
    var target = item.el.querySelector('[data-cdi-dv-nav-target]');
    if (!target || !target.getClientRects().length) target = item.el;
    target.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', a.hash);
  });
})();
